const division = [
  {id: 'front', name: 'front'},
  {id: 'end', name: 'end'},
  {id: 'productBanner', name: '품목 배너'}
]

export {division}
